<template>
  <el-dialog
      :title="dialogTitle"
      :visible.sync="visible"
      width="800px"
      @open="handleOpen"
      @close="handleClose"
      :append-to-body="appended">
    <div style="margin-top: 30px">
      <el-row>
        <el-col :span="7">
          <el-input v-model="keyword"
                    placeholder="输入品名/货号"
                    @keyup.native.enter="doKeywordSearchForStock"
                    class="input-item-short"
                    clearable
          ></el-input>
        </el-col>
        <el-col :span="7" v-if="vipSelectable">
          <vips :teamid="teamid" @teamChange="teamChange"></vips>
        </el-col>
        <el-col :span="7" v-if="platformSelectable">
          <el-select v-model="platformSelected" placeholder="平台选择">
            <el-option
                v-for="plat in PLATFORMS"
                :label="plat.label"
                :value="plat.value"
                :key="plat.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" @click="doKeywordSearchForStock" style="margin-top: 0px">搜索</el-button>
        </el-col>
        <el-col :span="8">
          <el-button type="warning" @click="confirmSelections" style="margin-top: 0px" v-if="multi">选择</el-button>
        </el-col>
      </el-row>
      <el-row style="margin-top: 8px; margin-bottom: 12px;">
        <el-col :span="6">
          <el-input v-model="resultFilterText" placeholder="结果中搜索" @clear="doFilter" clearable>
            <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
          </el-input>
        </el-col>
      </el-row>
      <el-tabs v-model="activeTab" type="card">
        <el-tab-pane label="从库存搜索" name="first">
          <el-row>
            <el-table
                v-loading="skuListLoading"
                :data="skuList.filter(item => !item.hidden)"
                border
                height="450px"
                style="width: 100%"
                ref="multipleTable1"
                @selection-change="onStockSelectionsChange"
            >
              <el-table-column type="selection" align="center" v-if="multi">
              </el-table-column>
              <el-table-column label="商品图片" align="center">
                <template slot-scope="props">
                  <el-image
                      class="img_box_mini"
                      :src="props.row.image"
                      :preview-src-list="[props.row.image]"
                  ></el-image>
                </template>
              </el-table-column>
              <el-table-column label="商品名称" prop="productName" align="center">
              </el-table-column>
              <el-table-column label="规格" prop="specs" align="center">
              </el-table-column>
              <el-table-column label="货号" prop="snCode" align="center">
              </el-table-column>
              <el-table-column label="库存" prop="stock" align="center">
              </el-table-column>
              <el-table-column label="选择" align="center">
                <template slot-scope="{row}">
                  <el-button type="success" size="mini" @click="confirmSku(row)">{{confirmBtn}}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row>
            <el-pagination
                @current-change="handleDialogCurrentChange"
                :current-page.sync="pageInfo.page"
                :page-size="pageInfo.size"
                layout="total, prev, pager, next"
                :total="pageInfo.total">
            </el-pagination>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="从订单搜索" name="second" v-if="fromOrder">
          <el-row>
            <el-table
                v-loading="skuListLoading2"
                :data="skuList2.filter(item => !item.hidden)"
                border
                height="450px"
                style="width: 100%"
                ref="multipleTable2"
                @selection-change="onSkuSelectionsChange"
            >
              <el-table-column type="selection" align="center" v-if="multi">
              </el-table-column>
              <el-table-column label="商品图片" align="center">
                <template slot-scope="props">
                  <el-image
                      class="img_box_mini"
                      :src="props.row.image"
                      :preview-src-list="[props.row.image]"
                  ></el-image>
                </template>
              </el-table-column>
              <el-table-column label="商品名称" prop="productName" align="center">
              </el-table-column>
              <el-table-column label="规格" prop="specs" align="center">
              </el-table-column>
              <el-table-column label="货号" prop="snCode" align="center">
              </el-table-column>
              <el-table-column label="选择" align="center">
                <template slot-scope="{row}">
                  <el-button type="success" size="mini" @click="confirmSku(row)">{{confirmBtn}}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row>
            <el-pagination
                :current-page.sync="pageInfo2.page"
                :page-size="pageInfo2.size"
                layout="total, prev, pager, next"
                :total="pageInfo2.total">
            </el-pagination>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="从商品搜索" name="third" v-if="fromProduct">
          <el-row>
            <el-table
                v-loading="skuListLoading3"
                :data="skuList3.filter(item => !item.hidden)"
                border
                height="450px"
                style="width: 100%"
                ref="multipleTable3"
                @selection-change="onProductSkuSelectionsChange"
            >
              <el-table-column type="selection" align="center" v-if="multi">
              </el-table-column>
              <el-table-column label="商品图片" align="center">
                <template slot-scope="props">
                  <el-image
                      class="img_box_mini"
                      :src="props.row.image"
                      :preview-src-list="[props.row.image]"
                  ></el-image>
                </template>
              </el-table-column>
              <el-table-column label="商品名称" prop="productName" align="center">
                <template slot-scope="{row}">
                  {{row.productName}}
                </template>
              </el-table-column>
              <el-table-column label="规格" prop="specs" align="center">
              </el-table-column>
              <el-table-column label="货号" prop="snCode" align="center">
              </el-table-column>
              <el-table-column label="选择" align="center">
                <template slot-scope="{row}">
                  <el-button type="success" size="mini" @click="confirmSku(row)">{{confirmBtn}}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row>
            <el-pagination
                :current-page.sync="pageInfo3.page"
                :page-size="pageInfo3.size"
                layout="total, prev, pager, next"
                :total="pageInfo3.total">
            </el-pagination>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <div style="height: 10px">
      </div>
    </div>
  </el-dialog>
</template>

<script>
import packagedApi from '../../request/packagedApi'
import remnantApi from '../../request/remnantApi'
import platformUtils from '../../utils/platformUtils'

export default {
  props: {
    teamid: {
      type: Number
    },
    visible: {
      type: Boolean
    },
    title: {
      type: String
    },
    plat: {
      type: Number
    },
    confirmBtnText: {
      type: String
    },
    multi: {
      type: Boolean,
      default: false
    },
    appended: {
      type: Boolean,
      default: false
    },

    //是否可以选择具体的平台
    platformSelectable: {
      type: Boolean,
      default: false,
    },

    vipSelectable: {
      type: Boolean,
      default: false
    },
    fromOrder: {
      type: Boolean,
      default: true
    },

    fromProduct: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      //teamId: this.teamid,
      activeTab: 'first',
      dialogTitle: this.title || '',
      keyword: '',
      skuListLoading: false,
      skuList: [],
      skuListLoading2: false,
      skuList2: [],
      skuListLoading3: false,
      skuList3: [],
      pageInfo: {
        page: 0,
        size: 20,
        total: 0
      },
      pageInfo2: {
        page: 0,
        size: 20,
        total: 0
      },
      pageInfo3: {
        page: 0,
        size: 20,
        total: 0
      },

      confirmBtn: this.confirmBtnText || '选择',

      selections1: [],
      selections2: [],
      selections3: [],

      selections: [],

      PLATFORMS: [],
      platformSelected: null,

      searchTeam: null,
      resultFilterText: ''
    }
  },

  methods: {
    doFilter() {
      const filterText = this.resultFilterText || ''
      const skuList = this.skuList
      const skuList2 = this.skuList2
      const skuList3 = this.skuList3
      this.doFilterForList(skuList, filterText)
      this.doFilterForList(skuList2, filterText)
      this.doFilterForList(skuList3, filterText)
    },

    doFilterForList(list, text) {
      if (list && list.length) {
        list.forEach(item => {
          let fullText = ''
          fullText += (item.productName || '')
          fullText += (item.snCode || '')
          fullText += (item.specs || '')
          this.$set(item, 'hidden', fullText.indexOf(text) <= -1)
        })
      }
    },

    teamChange(val) {
      this.$emit('teamChange', val)
    },

    confirmSelections() {
      const selections = this.selections1.concat(this.selections2).concat(this.selections3)
      const copies = JSON.parse(JSON.stringify(selections))
      this.$refs.multipleTable1.clearSelection()
      if (this.fromOrder)
        this.$refs.multipleTable2.clearSelection()
      if (this.fromProduct)
        this.$refs.multipleTable3.clearSelection()
      this.$emit('confirmMultipleSelections', copies)
    },

    onStockSelectionsChange(selection) {
      const stockSels = []
      const skuSels = this.selections2
      const productSkuSels = this.selections3
      const skuIds = skuSels.map(s => s.skuId)
      const skuIds2 = productSkuSels.map(s => s.skuId)

      selection.forEach(s => {
        const flag = skuIds.indexOf(s.skuId) > -1 || skuIds2.indexOf(s.skuId) > -1
        if(flag) {
          console.log(this.$refs.multipleTable1)
          this.$refs.multipleTable1.toggleRowSelection(s)
          this.$message.warning('此款商品已选')
        } else {
          console.log(s)
          stockSels.push(s)
        }
      })
      this.selections1 = stockSels
    },

    onSkuSelectionsChange(selection) {
      const stockSels = this.selections1
      const productSkuSels = this.selections3
      const skuSels = []
      const skuIds = stockSels.map(s => s.skuId)
      const skuIds2 = productSkuSels.map(s => s.skuId)
      selection.forEach(s => {
        const flag = skuIds.indexOf(s.skuId) > -1 || skuIds2.indexOf(s.skuId) > -1
        if(flag) {
          console.log(this.$refs.multipleTable2)
          this.$refs.multipleTable2.toggleRowSelection(s)
          this.$message.warning('此款商品已选')
        }else {
          console.log(s)
          skuSels.push(s)
        }
      })
      this.selections2 = skuSels
    },

    onProductSkuSelectionsChange(selection) {
      const stockSels = this.selections1
      const skuSels = this.selections2
      const productSkuSels = []
      const skuIds = stockSels.map(s => s.skuId)
      const skuIds2 = skuSels.map(s => s.skuId)
      selection.forEach(s => {
        const flag = skuIds.indexOf(s.skuId) > -1 || skuIds2.indexOf(s.skuId) > -1
        if(flag) {
          console.log(this.$refs.multipleTable3)
          this.$refs.multipleTable3.toggleRowSelection(s)
          this.$message.warning('此款商品已选')
        }else {
          console.log(s)
          productSkuSels.push(s)
        }
      })
      this.selections3 = productSkuSels
    },

    handleOpen() {
      //初始化
      this.keyword = ''
      this.skuList = []
      this.skuList2 = []
      this.skuList3 = []
      this.doKeywordSearchForStock()
    },

    handleClose() {
      this.$emit('dialogClose')
    },

    confirmSku(row) {
      const teamId = this.searchTeam
      this.$emit('confirmSelection', row, teamId)
    },

    handleDialogCurrentChange(val) {
      let keyword = this.keyword
      if (!keyword) {
        this.onLoadSkuList(val - 1, null, null)
      } else {
        this.findStockByKeyword(keyword, val - 1)
      }
    },

    doKeywordSearchForStock() {
      let keyword = this.keyword
      if (keyword && keyword.length < 3) {
        this.$message({
          message: '关键字过短',
          type: 'warning'
        })
        return
      }
      this.searchTeam = this.teamid
      if (!keyword) {
        this.onLoadSkuList(null, null, null)
        this.$data.skuList2 = []
        this.$data.skuList3 = []
        return
      }
      this.findStockByKeyword(keyword, 0)
      if (this.fromOrder) {
        this.doKeywordSearchForOrder(keyword)
      }
      if (this.fromProduct) {
        this.doKeywordSearchForProduct(keyword)
      }

    },

    doKeywordSearchForProduct(keyword) {
      this.skuListLoading3 = true
      this.pageInfo.page = 1
      this.skuList3 = []

      const platform = this.plat || this.platformSelected || 0
      packagedApi
          .searchByProductKeyword(keyword, this.teamid, platform).then(response => {
        console.log('by keyword res', response)
        this.skuList3 = response.rows
        this.pageInfo3.total = response.rows.length
        this.pageInfo3.size = response.rows.length
        this.skuListLoading3 = false
      }).catch(err => {
        console.log('by keyword err', err)
        this.skuListLoading3 = false
      })
    },

    doKeywordSearchForOrder(keyword, page) {
      page = page || 0
      this.skuListLoading2 = true
      this.pageInfo.page = 1
      this.skuList2 = []
      const platform = this.plat || this.platformSelected || 0
      packagedApi
          .searchByKeyword(platform, keyword, 3, 90, this.teamid).then(response => {
        console.log('by keyword res', response)
        this.skuList2 = response.rows
        this.pageInfo2.total = response.rows.length
        this.pageInfo2.size = response.rows.length
        this.skuListLoading2 = false
      }).catch(err => {
        console.log('by keyword err', err)
        this.skuListLoading2 = false
      })

    },

    findStockByKeyword(keyword, page) {
      this.skuListLoading = true
      this.skuList = []
      page = page || 0
      const query = {
        page,
        size: this.pageInfo.size ? this.pageInfo.size : 20,
        teamId: this.teamid,
        keyword: keyword
      }

      remnantApi.findStocksV2(query).then(response => {
        this.skuList = response.data
        this.pageInfo.total = response.total
        this.pageInfo.page = response.page
        this.skuListLoading = false
      }).catch(err => {
        console.log('stock by keyword err', err)
        this.skuListLoading = false
      })

    },

    onLoadSkuList(page, size, skuId) {
      //加载动画
      this.skuListLoading = true
      const query = {
        page: page ? page : 0,
        size: size ? size : 20,
        teamId: this.teamid
      }
      remnantApi.findStocksV2(query).then((data) => {
        let list = data.data.map((item) => {
          return item
        })
        this.skuList = list
        this.skuListLoading = false
        this.pageInfo.page = data.page
        this.pageInfo.total = data.total
      })
    },
  },

  mounted() {
    this.PLATFORMS = platformUtils.getOptions(false, true, true)
  },
}
</script>

<style scoped>

.cell {
  font-size: 12px;
  text-align: center;
  padding: 0;
}

.el-table td,
.el-table th {
  padding: 4px 0;
}

.table_box {
  margin-top: 12px;
}

.el-table .cell,
.el-table th div {
  padding-left: 0px;
  padding-right: 0px;
}

.img_box_mini {
  width: 50px;
  height: 55px;
}

.input-item-short {
  width: 200px;
  height: 44px;
}

</style>
le>


// WEBPACK FOOTER //
// src/components/SkuSelection/index.vue